import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import { ThreeFoursModal } from 'widgets/ThreeFours';
import { getThreeFoursAvailability } from 'store/widgets/ThreeFours/selectors';
import { cookieBasketService } from 'services';
import commonStyles from 'styles/common.pcss';
import {
  getSharedZonePageHasNavigation,
  getSharedZonePageShowBreadcrumbs,
  getSharedZoneContentSettings,
  getSharedZonePageHasTradeInBanner,
} from 'store/SharedZone/selectors';
import { SharedZoneBlocks } from 'store/SharedZone/blocks/selectors';
import { SharedZoneBlocksContext } from 'store/SharedZone/blocks/contexts';

import PopularArticlesWidget from './components/PopularArticlesWidget';
import BannerContainer from './components/BannerContainer';
import BreadcrumbsWidget from './components/BreadcrumbsWidget';
import PageLayout from '../_PageLayout';
import SwitchBlock from './blocks/_SwitchBlock';
import { SHARED_ZONE_NEW } from './constants';
import { SharedZoneNew } from './SharedZoneNew/index';

const cx = classNames.bind(commonStyles);

const SharedZone = () => {
  const {
    blockIds,
    hasNavigation,
    hasTradeInBanner,
    showBreadcrumbs,
    hasThreeFours,
    contentSettings,
  } = useSelector(
    (state) => ({
      blockIds: SharedZoneBlocks.getBlockIds(state),
      hasNavigation: getSharedZonePageHasNavigation(state),
      hasTradeInBanner: getSharedZonePageHasTradeInBanner(state),
      showBreadcrumbs: getSharedZonePageShowBreadcrumbs(state),
      hasThreeFours: getThreeFoursAvailability(state),
      contentSettings: getSharedZoneContentSettings(state),
    }),
    shallowEqual,
  );

  const { page, damProdam, settings } = contentSettings;

  useEffect(() => {
    cookieBasketService.updateBasketIdCookie();
  }, []);

  if (page === SHARED_ZONE_NEW.PAGE_SLUG) {
    return (
      <SharedZoneNew
        hasNavigation={hasNavigation}
        hasThreeFours={hasThreeFours}
        damProdam={damProdam}
        settings={settings}
      />
    );
  }

  return (
    <PageLayout
      withNavigation={hasNavigation}
      withTradeIn={hasTradeInBanner}
      beforeContent={hasThreeFours && <ThreeFoursModal />}
    >
      <BannerContainer className={cx('marb-l')} />
      {showBreadcrumbs && <BreadcrumbsWidget />}
      {blockIds.map((blockId) => (
        <SharedZoneBlocksContext.Provider value={blockId} key={blockId}>
          <SwitchBlock />
        </SharedZoneBlocksContext.Provider>
      ))}
      <PopularArticlesWidget />
    </PageLayout>
  );
};

export default SharedZone;
